/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInApiResponse
 */
export interface SignInApiResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof SignInApiResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof SignInApiResponse
     */
    message: string;
}

export function SignInApiResponseFromJSON(json: any): SignInApiResponse {
    return SignInApiResponseFromJSONTyped(json, false);
}

export function SignInApiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInApiResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function SignInApiResponseToJSON(value?: SignInApiResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

